<template>
    <button class="bg-[#49AB41] text-base rounded-sm py-4 w-full text-white font-semibold"
    @click="openCommentModal">{{ $t('page.writeComment') }}</button>
</template>

<script>
export default {
  methods: {
    openCommentModal(){
      if (this.$store.authStatus){
            this.$store.modals.commentModal = true
        }else{
            this.$store.loginModal = true
        }
    }
  }
};
</script>

<!-- v-if="detail?.allow_comments"  -->